import {URL_BASE_API } from '../../configs/urlConfigs';
import {LOGIN_AFFILIATE_GROUP} from '../../configs/staticConfigs';
import {userGroupUrlCheck} from '../../utils/userGroupUrlCheck';

import service from '../api';

let userGroup = ''; 

export const userDocMasterList = (request) => {
    let ENDPOINT = '';
    if(request.data!==undefined){    
      let userType = request.data.userType;
      let column   = request.data.column;
      if(column){
        ENDPOINT = URL_BASE_API+'super-admin/userdocs/?search='+userType+'&column='+column;
      }else{
        ENDPOINT = URL_BASE_API+'super-admin/userdocs/?search='+userType;
      } 
    }  
    return service.get(ENDPOINT);
};

export const userDocList = (request) => {
    let userGroupData = userGroupUrlCheck(window.location);
    if(userGroupData!==undefined){
        userGroup = userGroupData.user_group; 
    }
    let ENDPOINT = '';
    if(request.data!==undefined){    
      let userType = request.data.userType;
      let column   = request.data.column;
      let document = request.data.document ? request.data.document : 0;
      let client_id= request.data.client_id ? request.data.client_id : 0;

      if(userGroup===LOGIN_AFFILIATE_GROUP){
        if(column){
          ENDPOINT = URL_BASE_API+'affiliate/docs_v2/?user='+userType+'&column='+column;
        }else{
          ENDPOINT = URL_BASE_API+'affiliate/docs_v2/?user='+userType;
        }
        // VARIABLES document AND client_id ARE PASSED ON THE REQUEST OF SERVER TEAM ON 24Nov2020 
        if(document > 0) ENDPOINT += '&document='+document;
        if(client_id > 0) ENDPOINT += '&client_id='+client_id;

      }else{
        if(column){
          ENDPOINT = URL_BASE_API+'super-admin/userdocs/?search='+userType+'&column='+column;
        }else{
          ENDPOINT = URL_BASE_API+'super-admin/userdocs/?search='+userType;
        }
      }     
     
    }  

    return service.get(ENDPOINT);
    
};


export const userDocAdd = (request) => {
  let userGroupData = userGroupUrlCheck(window.location);
  if(userGroupData!==undefined){
      userGroup = userGroupData.user_group; 
  }
  let ENDPOINT = '';
  if(userGroup===LOGIN_AFFILIATE_GROUP){
    ENDPOINT = URL_BASE_API+'affiliate/docs_v2/';
  }else{
    ENDPOINT = URL_BASE_API+'super-admin/userdocs/';
  }

  return service.post(ENDPOINT,request.data);
  
};

export const userDocEdit = (request) => {
  let userGroupData = userGroupUrlCheck(window.location);
  if(userGroupData!==undefined){
      userGroup = userGroupData.user_group; 
  }
  let userDocId = request.data;
  let ENDPOINT = '';
  if(userGroup===LOGIN_AFFILIATE_GROUP){
    ENDPOINT = URL_BASE_API+'affiliate/docs_v2/'+userDocId;
  }else{
    ENDPOINT = URL_BASE_API+'super-admin/userdocs/'+userDocId;
  }

  return service.get(ENDPOINT);  
  
};


export const userDocUpdate = (request) => {
  let userGroupData = userGroupUrlCheck(window.location);
  if(userGroupData!==undefined){
      userGroup = userGroupData.user_group; 
  }
  let userDocId = request.data.id;
  let ENDPOINT = '';
  if(userGroup===LOGIN_AFFILIATE_GROUP){
    ENDPOINT = URL_BASE_API+'affiliate/docs_v2/'+userDocId;
  }else{
    ENDPOINT = URL_BASE_API+'super-admin/userdocs/'+userDocId;
  }

  return service.put(ENDPOINT,request.data);  
  
};

export const userDocDelete = (request) => {
  let userGroupData = userGroupUrlCheck(window.location);
  if(userGroupData!==undefined){
      userGroup = userGroupData.user_group; 
  }
  let ENDPOINT = '';
  if(userGroup===LOGIN_AFFILIATE_GROUP){
    ENDPOINT = URL_BASE_API+'affiliate/docs_v2/'+request.data;
  }else{
    ENDPOINT = URL_BASE_API+'super-admin/userdocs/'+request.data;
  }
  return service.delete(ENDPOINT);   
};  